import PropTypes from 'prop-types';
import React from 'react';

const InlineOverlayFooter = ({ children }) => <div className="content-footer clearfix">{children}</div>;

InlineOverlayFooter.displayName = 'InlineOverlayFooter';
InlineOverlayFooter.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default InlineOverlayFooter;
